var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({class:[
    ("btn btn-" + (_vm.props.type)),
    _vm.data.staticClass,
    _vm.data.class
  ],attrs:{"type":_vm.props.submit ? 'submit' : 'button',"disabled":_vm.props.disabled}},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }